const priceSuggestionDomains = {
  computed: {
    // Valores do `SkuPriceSuggestionStatusEnum` (Status_Terminal da Tentativa) — Req 14.2, 14.5.
    // Correspondem aos nomes do enum no backend e são usados tanto como valor do filtro
    // enviado na query (`status`) quanto como chave para resolver o rótulo em português.
    skuPriceSuggestionStatusEnum() {
      return {
        APPLIED: 'Applied',
        APPLIED_WITH_MINIMUM_MARGIN: 'AppliedWithMinimumMargin',
        NOT_CHANGED: 'NotChanged',
        REJECTED_VARIATION_LIMIT: 'RejectedVariationLimit',
        REJECTED_MISSING_CONFIGURATION: 'RejectedMissingConfiguration',
        REJECTED_INVALID_COST: 'RejectedInvalidCost',
        REJECTED_TIERED_MINIMUM_MARGIN: 'RejectedTieredMinimumMargin',
        PROCESSING_ERROR: 'ProcessingError',
      }
    },

    // Mapa status -> rótulo em português, resolvido via chaves i18n `PRICE_SUGGESTION_LOG.STATUS.*`.
    skuPriceSuggestionStatusLabel() {
      const e = this.skuPriceSuggestionStatusEnum
      return {
        [e.APPLIED]: this.$t(`PRICE_SUGGESTION_LOG.STATUS.${e.APPLIED}`),
        [e.APPLIED_WITH_MINIMUM_MARGIN]: this.$t(
          `PRICE_SUGGESTION_LOG.STATUS.${e.APPLIED_WITH_MINIMUM_MARGIN}`
        ),
        [e.NOT_CHANGED]: this.$t(`PRICE_SUGGESTION_LOG.STATUS.${e.NOT_CHANGED}`),
        [e.REJECTED_VARIATION_LIMIT]: this.$t(
          `PRICE_SUGGESTION_LOG.STATUS.${e.REJECTED_VARIATION_LIMIT}`
        ),
        [e.REJECTED_MISSING_CONFIGURATION]: this.$t(
          `PRICE_SUGGESTION_LOG.STATUS.${e.REJECTED_MISSING_CONFIGURATION}`
        ),
        [e.REJECTED_INVALID_COST]: this.$t(
          `PRICE_SUGGESTION_LOG.STATUS.${e.REJECTED_INVALID_COST}`
        ),
        [e.REJECTED_TIERED_MINIMUM_MARGIN]: this.$t(
          `PRICE_SUGGESTION_LOG.STATUS.${e.REJECTED_TIERED_MINIMUM_MARGIN}`
        ),
        [e.PROCESSING_ERROR]: this.$t(`PRICE_SUGGESTION_LOG.STATUS.${e.PROCESSING_ERROR}`),
      }
    },
  },

  methods: {
    // Opções `{ value, label }` para o filtro `vue-select` (Req 14.2), na ordem de declaração do enum.
    skuPriceSuggestionStatusOptions() {
      const labels = this.skuPriceSuggestionStatusLabel
      return Object.keys(labels).map(value => ({ value, label: labels[value] }))
    },

    // Resolve o rótulo em português de um `status` para a coluna `Status` (Req 14.5).
    // Retorna '—' quando o status for nulo/ausente e o próprio valor como fallback sem rótulo.
    getSkuPriceSuggestionStatusLabel(status) {
      if (!status) return '—'
      return this.skuPriceSuggestionStatusLabel[status] || status
    },
  },
}

export default priceSuggestionDomains
